import React from 'react';
import { marketplaceBrands } from '../data/mock';

const BrandCard = ({ brand }) => {
  const isLive = brand.status === 'live';
  const hasLogo = brand.logoUrl;
  
  const cardContent = (
    <div className="flex flex-col items-center">
      <div 
        className={`
          w-36 h-36 md:w-44 md:h-44 rounded-full flex items-center justify-center overflow-hidden
          transition-all duration-300
          ${isLive 
            ? 'bg-gray-800 border-2 border-gray-200 shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer' 
            : hasLogo 
              ? 'bg-black border-2 border-gray-200 opacity-50 grayscale'
              : 'bg-gray-100 border-2 border-gray-200 opacity-50'
          }
        `}
      >
        {hasLogo ? (
          <img 
            src={brand.logoUrl}
            alt={`${brand.name} Logo`}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-sm text-gray-400 font-medium">{brand.name}</span>
        )}
      </div>
      <p className={`
        mt-4 text-sm font-medium
        ${isLive ? 'text-gray-800' : 'text-gray-400'}
      `}>
        {brand.label}
      </p>
      {isLive && (
        <span className="mt-2 inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-700">
          Active
        </span>
      )}
      {!isLive && brand.name !== "Coming Soon" && (
        <span className="mt-2 text-xs text-gray-400">
          Coming Soon
        </span>
      )}
    </div>
  );

  if (isLive && brand.link) {
    return (
      <a 
        href={brand.link} 
        target="_blank" 
        rel="noopener noreferrer"
        className="no-underline"
      >
        {cardContent}
      </a>
    );
  }

  return cardContent;
};

const MarketplaceBrands = () => {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-24">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-16 text-center">
          Our Marketplace Brands
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-16">
          {marketplaceBrands.map((brand) => (
            <BrandCard key={brand.id} brand={brand} />
          ))}        </div>
        
        {/* Strategy Flow */}
        <div className="mt-16 text-center">
          <p className="text-lg md:text-xl font-medium text-gray-700 flex flex-wrap items-center justify-center gap-2">
            <span>Own the service</span>
            <span>➡️</span>
            <span>Own the workflow</span>
            <span>➡️</span>
            <span>Own the data</span>
            <span>➡️</span>
            <span>Own the network</span>
            <span>➡️</span>
            <span className="font-semibold text-gray-900">Win the market 🎉</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default MarketplaceBrands;
